/*----- Core -----*/
import React     from 'react'
import styled    from 'styled-components'
import PropTypes from 'prop-types'

/*----- Components -----*/
import Title from '../text/Title'
import Paragraph from '../text/Paragraph'
import Device from '../../commons/Device'

/*----- Styles-----*/
const StyledQuoteCard = styled.article`
	border-radius: 6px;
	display: flex;
	flex-direction: row;
	justify-content: start;
	border-radius: 8px;
	padding-bottom: 16px;
	margin-bottom: 32px;
	background: white;
	padding: 32px;
	box-shadow: 0px 10px 50px 0px rgba(0, 0, 0, 0.05);
	.quote-card__title {
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: flex-start;
		height: 34px;
		height: fit-content;
		margin-left: 32px;
		.custom-paragraph {
			line-height: 20px;
			margin: 0;
		}
	}
	.quote-card__image-container {
		position: relative;
		img {
			width: 60px;
			border-radius: 50%;
		}
	}

	@media ${ Device.lg } {
		margin: 16px;
	}
`

/*----- Export -----*/
const QuoteCard = ({ imageUrl, name, description }) => (
	<StyledQuoteCard className="quote-card">
		<div className="quote-card__image-container">
			<img src={imageUrl} alt="person"/>
		</div>
		<div className="quote-card__title">
			<Title content={ name } size={5} />
			<Paragraph content={ description } />
		</div>
	</StyledQuoteCard>
)
export default QuoteCard

/*----- PropTypes -----*/
QuoteCard.propTypes = {
	imageUrl:    PropTypes.string.isRequired,
	name:        PropTypes.string.isRequired,
	description: PropTypes.string.isRequired
}
